<terra-welcome-layout [showReleaseNotification]="false">
  <section class="welcome-text">Nice to meet you</section>

  <section class="welcome-sub-text">
    We’re here to help build your portfolio with tools to manage your acquisition pipeline
  </section>

  <section class="form-content">

    <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
      <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
    </ng-container>

    <form class="form terra-error-style" [formGroup]="registerForm" (ngSubmit)="register()">
      <terra-loader *ngIf="isLoadingInvitationDetails$ | async else content" class="invitation-loader"></terra-loader>
      <ng-template #content>
        <ng-container *ngIf="!!invitationToken  else noInvitation">
          <ng-container *ngIf="organizationInvitation$ | async as invitation">
            <span class="title">
              You have been invited to join {{invitation.organizationName}}
              <br>
              Let's set up your account:
            </span>
          </ng-container>
          <ng-container *ngIf="invitationErrorMessage$ | async as errorMessage">
            <p class="error">
              {{errorMessage}}
              <br>
              Please
              <a target="_blank" href="https://www.covercy.com/contact-us/" class="link">contact our support team</a>
              and provide this token: <strong>{{invitationToken}}</strong>
            </p>
          </ng-container>
        </ng-container>
        <ng-template #noInvitation>
          <h1>Sign up</h1>

          <p class="goto-login">
            Already have an account?
            <a [routerLink]="routingService.loginGpPage" class="link" queryParamsHandling="preserve" routerLinkActive="active">Log in</a>
          </p>
        </ng-template>
        <ng-container *ngIf="!(invitationErrorMessage$ | async)">
          <!-- First name -->
          <mat-form-field appearance="outline" class="input-width">
            <input matInput autocomplete="given-name" placeholder="First name" formControlName="firstName" />
            <mat-error *ngIf="registerForm.get('firstName').hasError('required')">Required</mat-error>
            <mat-error *ngIf="registerForm.get('firstName').hasError('minlength')">First name must be more than one character</mat-error>
          </mat-form-field>

          <!-- Last name -->
          <mat-form-field appearance="outline" class="input-width">
            <input matInput autocomplete="new-lastName" placeholder="Last name" formControlName="lastName" />
            <mat-error *ngIf="registerForm.get('lastName').hasError('required')">Required</mat-error>
            <mat-error *ngIf="registerForm.get('lastName').hasError('minlength')">Last name must be more than one character</mat-error>
          </mat-form-field>

          <terra-phone-country-picker formControlName="phone" (countryChanged)="addCountryId($event)" [isOuterFormSubmitted]="hasPhoneError">
          <mat-error *ngIf="registerForm.get('phone').hasError('required')">Required</mat-error>
          </terra-phone-country-picker>

          <!-- Email address -->
          <mat-form-field appearance="outline" class="input-width-smallWidth">
            <input matInput placeholder="Company email" formControlName="username" />
            <mat-error *ngIf="registerForm.get('username').hasError('email')">
              Please enter a valid email address
            </mat-error>
            <mat-error *ngIf="registerForm.get('username').hasError('required')">
              Email is required
            </mat-error>
          </mat-form-field>

          <!-- Password -->
          <mat-form-field appearance="outline" class="input-width password-wrapper">
            <input [type]="showPassword ? 'text' : 'password'"
                   matInput
                   placeholder="Create a password"
                   formControlName="password"
                   maxlength="16"
                   class="lo_sensitive"
                   autocomplete="new-password" />
            <mat-icon *ngIf="!isLoading" matSuffix (click)="showPassword = !showPassword" class="show-password-icon notranslate" color="primary">remove_red_eye</mat-icon>
            <mat-error *ngIf="registerForm.get('password').hasError('required')">
              Password is required
            </mat-error>
            <mat-error *ngIf="
                !registerForm.get('password').hasError('required') &&
                (registerForm.get('password').hasError('passwordstrength') || registerForm.get('password').hasError('minlength'))
              ">Password should be at least 8 characters and contain at least one letter and one digit
            </mat-error>
          </mat-form-field>

          <ngx-recaptcha2 #recaptcha formControlName="recaptcha" class="recaptcha"
                          [siteKey]="appSettingsService.recaptchaPublicKey">
          </ngx-recaptcha2>
          <mat-error *ngIf="showCaptchaError && registerForm.get('recaptcha').hasError('required')" class="recaptcha-error">
            Please verify you're not a robot
          </mat-error>

          <!-- Sign up button -->
          <div class="input-width">
            <button type="submit" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading">
              {{ !!invitationToken ? 'Set Up Account' : 'Sign Up'}}
            </button>
          </div>

          <p class="error-message" *ngIf="showSubmitError">{{ error }}</p>

          <div class="authorized-uk">
            <mat-icon class="notranslate">verified_user</mat-icon>
            Authorised by the UK FCA
          </div>

          <p class="terms-info">
            By creating an account, I agree to Covercy's
            <a href="https://www.covercy.com/covercy-gp-terms-and-conditions" class="mat-primary" target="_blank">Terms and conditions</a>.
          </p>

          <terra-loader [centerToParent]="true" *ngIf="isLoading"></terra-loader>
        </ng-container>
      </ng-template>
    </form>

    <div class="data-safe">
      <img src="/assets/images/icons/data-safe.png"/>
    </div>
  </section>
</terra-welcome-layout>
